module.exports = __webpack_public_path__ + "static/media/SohoGothicProRegular.5baa11c6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SohoGothicProRegular.woff
// module id = 831
// module chunks = 0